import React,{useState, useEffect} from 'react';
import Map from '@components/map';
import Clock from '@components/clock';
import Comments from '@components/comments';
import Avatar from '@components/avatar';
import CountryList from '@components/country-list';
import dan from '@static/images/dan.png'
import './App.css';
import {whereisdan} from '@firebase/fire'
import { HashRouter as Router, Route } from 'react-router-dom';

let touchedCountries = []
let timeouts = []
const DAN_HEIGHT = 40

function resetBoard(){
  touchedCountries.forEach(countryElement=>{
    countryElement.style.fill = "green"
  })
}

const safeGet = (args, obj)=> args
  .split('.')
  .reduce((final, value) => (final || {})[value], obj)

function onMapClick(e,x,y){
  if(safeGet('target.id', e)){
    whereisdan.push({
      countryCode: safeGet('target.id', e) || null,
      date:new Date().getTime(),
      title:safeGet('target.attributes.title.value',e) || null,
      x:!!x ? x : null,
      y:!!y ? y  : null
    });
  }
}

function formatVisitedDate(time) {
  var monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
  ];
  const date = new Date(time)
  return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`
}


function moveDan(x,y){
  const dan = document.getElementById('danface')
  dan.style.left = "" + (x - DAN_HEIGHT/2) + "px"
  dan.style.top = "" + (y  - DAN_HEIGHT/2) + "px"
}


function moveToCountry(id, i, context,x,y, d){
  const dan = document.getElementById('danface')
  const [x1,y1] = [parseInt(dan.style.left), parseInt(dan.style.top)]
  let x2 = 0
  let y2 = 0
  if(id){
    const countryElement = document.getElementById(id)
    const countryBbox = countryElement.getBBox()
    touchedCountries.push(countryElement)
    x2 = countryBbox.x + countryBbox.width/2
    y2 = countryBbox.y + countryBbox.height/2
    countryElement.style.fill = "red"
  }else if(!!x && !!y){
    x2 = x
    y2 = y
  }
  if(x2 && y2){moveDan(x2,y2)}
  if(i >0){animate(x1,y1,x2,y2,0,context);}
}

function visitCountry(id, i, context,x,y, d){
  let timeoutId = setTimeout(() => {moveToCountry(id, i, context,x,y, d)}, 1000 * i);
  timeouts.push(timeoutId)
}



 function drawLine(x1,y1,x2,y2,ratio, context,show) {
   context.beginPath();
   context.moveTo(x1,y1);
   x2 = x1 + ratio * (x2-x1);
   y2 = y1 + ratio * (y2-y1);
   context.lineTo(x2,y2);
   if(show){
     context.stroke();
   }
 }

 function animate(x1,y1,x2,y2, ratio, context, d) {
   d = !d
   ratio = ratio || 0;
   drawLine(x1,y1,x2,y2,ratio, context,d);
   if(ratio<1) {
     requestAnimationFrame(() => {animate(x1,y1,x2,y2,ratio + 0.02, context, d)});
   }

 }

function removeCountry(key){
  whereisdan.child(key).remove();
}


const ControlPanel = () => {
  const [visited,setVisited] = useState([])
  useEffect(_=>{
    whereisdan.on("value", snapshot => {
      const canvas = document.getElementById("mapcanvas")
      const context = canvas.getContext('2d')
      context.clearRect(0,0,canvas.width, canvas.height)
      const fbVals = snapshot.val() || {}
      const newVisited = Object.keys(fbVals)
        .map(key => ({
          key,
          value:fbVals[key].title,
          date:fbVals[key].date,
          displayDate: formatVisitedDate(fbVals[key].date),
        }))
      let places = Object.values(fbVals).sort((x,y)=>x.date - y.date);
      setVisited(newVisited)
      resetBoard()
      places.forEach((x,i)=>moveToCountry(x.countryCode,i, context, x.x,x.y, x))
    });
  },[])

  const [_danX, setDanX] = useState(0)
  const [_danY, setDanY] = useState(0)
  const setDanPos = (e) => {
    const {clientX:x1, clientY:y1 } = e
    moveDan(x1,y1)
    setDanX(x1)
    setDanY(y1)
  }
  return <div className="App">
    <div id="mapContainer" >
      <canvas id="mapcanvas" width="1009.6727" height="665.96301"></canvas>
      <Map clk={e=>{e.persist();onMapClick(e)}}/>
      <Avatar setDanPos={setDanPos} src={dan} width={DAN_HEIGHT} />
    </div>
    <CountryList {...{visited, removeCountry}}/>
  </div>
}


const UI = ()=>{
  const [visited,setVisited] = useState([])
  const [placesVisited, setPlacesVisited] = useState(0)

  useEffect(_=>{
    whereisdan.on("value", snapshot => {
        const canvas = document.getElementById("mapcanvas")
        const context = canvas.getContext('2d')
        context.clearRect(0,0,canvas.width, canvas.height)
        const fbVals = snapshot.val() || {}
        const newVisited = Object.keys(fbVals)
        .map(key => ({
          key,
          value:fbVals[key].title,
          date:fbVals[key].date,
          displayDate: formatVisitedDate(fbVals[key].date),
        }))
        setVisited(newVisited)
        let places = Object.values(fbVals).sort((x,y)=>x.date-y.date );
        setPlacesVisited(places.length)
        resetBoard()
        timeouts.forEach(t=>{clearTimeout(t)})
        places.forEach((x,i)=>{visitCountry(x.countryCode,i, context, x.x,x.y, x)})
    });
  },[])
  return <div className="App">
        <h2>Places Visited: {placesVisited}</h2>
        <div id="mapContainer" >
          <canvas id="mapcanvas" width="1009.6727" height="665.96301"></canvas>
          <Map clk={e=>{}}/>
          <Avatar src={dan} width={DAN_HEIGHT} />
        </div>
        <CountryList {...{visited}}/>
        <Comments/>
      </div>
}


class App extends React.Component {
  render(){
    return (
      <>
        <h1>Where is Dan</h1>
        <Clock/>
        <Router basename={process.env.PUBLIC_URL}>
          <Route exact path="/" component={UI} />
          <Route exact path="/funtimer" component={ControlPanel} />
        </Router>
      </>
    );
  }
}


export default App;
